export default __webpack_public_path__ + "static/media/left_digit.fb43675a.png";